<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div 
  (click)="toggleExpansion()"
  class="w-full mb-round bg-white p-6 cursor-pointer transition-all duration-200"
>
  <div class="flex items-center gap-3 border-mbaza-gray-dark border-b pb-4 mb-4">
    @if (logoUrl) {
      <img
        [src]="logoUrl"
        [src]="logoUrl"
        alt="logo"
        class="h-10 w-10 hrink-0 rounded-lg"
      />
    } @else {
      <div class="h-8 w-8 shrink-0 rounded-full bg-gray-100"></div>
    }

    <div class="flex w-full items-center justify-between">
      <span class="max-w-[70%] truncate font-semibold">
        {{ author.length > 25 ? (author | slice: 0 : 25) + "..." : author }}
      </span>
      <span class="text-gray-500">{{ date | date: "dd MMM yyyy" }}</span>
    </div>
  </div>

  <!-- Content -->
  <div class="w-full flex flex-col gap-2">
    <span class="font-bold block text-[16px]">{{ title }}</span>
    <p
      class="leading-relaxed text-gray-700"
      [ngClass]="{ 'line-clamp-2': !isExpanded }"
    >
      {{ content }}
    </p>

    @if(isExpanded){
      <div class="flex items-center gap-2 border-t border-mbaza-gray-dark pt-4" (click)="onWhatsappShare()">
        <span class="font-bold text-black">Share:</span>
        <button>
          <img
            [src]="ASSET_CONSTANTS.I_whatsapp_share"
            alt="share"
            class="h-4 w-4 hover:cursor-pointer"
          />
        </button>
      </div>
    }
  </div>
</div>